import LoadingComponent from "components/LoadingComponent";
import DashboardLayout from "features/LayoutContainers/DashboardLayout";
import DashboardNavbar from "features/Navbars/DashboardNavbar";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createNotificationThunk,
  getAllNotifications,
  getNotificationThunk
} from "redux/slices/notificationSlice";
import { NewNotification, Notification } from "types/Notification";
import WithAuthWrapper from "withWrapper/withAuthWrapper";
import AddViewNotificationsModal from "./Modal";
import NotificationsTable from "./table";

const headers = [
  { id: "id", name: "Id" },
  { id: "title", name: "Title" },
  { id: "subtitle", name: "Subtitle" },
  { id: "created_at", name: "Created At" },
  { id: "actions", name: "Actions" }
];
const NotificationPage: React.FC = () => {
  const accessToken = localStorage.getItem("stmpz-token");
  const businessId = localStorage.getItem("stmpz-business-id") || "";
  const dispatch = useDispatch();
  const notifications = useSelector(getAllNotifications);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [isView, setViewModal] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<Notification>();
  const [hasFetched, setHasFetched] = useState(false);

  const getNotificationsPage = useCallback(
    async (page: number) => {
      if (accessToken) {
        await dispatch(getNotificationThunk({ accessToken, businessId }));
      }
    },
    [accessToken, businessId, dispatch]
  );
  useEffect(() => {
    if (accessToken && !hasFetched) {
      setHasFetched(true);
      getNotificationsPage(1);
    }
  }, [accessToken, hasFetched, getNotificationsPage]);

  const createNotification = useCallback(
    async (newNotification: NewNotification) => {
      if (accessToken) {
        await dispatch(
          createNotificationThunk({ accessToken, newNotification, businessId })
        );
        setModalOpen(false);
        getNotificationsPage(1);
      }
    },
    [accessToken, businessId, dispatch, getNotificationsPage]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddViewNotificationsModal
        open={isModalOpen}
        isView={isView}
        selectedRow={selectedRow}
        handleClose={() => setModalOpen(false)}
        createNewNotification={createNotification}
      />
      {!!notifications ? (
        <NotificationsTable
          header={headers}
          rows={notifications}
          onPageChanged={(newPage: number) => getNotificationsPage(newPage + 1)}
          onReload={() => getNotificationsPage(1)}
          addNewOrViewNotifications={(
            isView: boolean,
            selectedRow?: Notification
          ) => {
            setSelectedRow(selectedRow);
            setViewModal(isView);
            setModalOpen(true);
          }}
        />
      ) : (
        <LoadingComponent />
      )}
    </DashboardLayout>
  );
};

export default WithAuthWrapper(NotificationPage);
